export default {"src":"https://s.sylndr.com/c-fd0c3a5/_next/static/media/contactIconGreen.ea9cc79e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};